module.exports = __webpack_public_path__ + "img/李立根.bd5aaf31.png";